import { createAsyncThunk } from '@reduxjs/toolkit';
import { wordSearchService } from '../../services/word-search.service';
export const getWordSearches = createAsyncThunk('wordSearches/get', async ({ status }, { fulfillWithValue, rejectWithValue }) => {
    try {
        const wordSearches = await wordSearchService.getWordSearches({ status });
        return fulfillWithValue({ wordSearches: [...wordSearches] });
    }
    catch (error) {
        return rejectWithValue(error instanceof Error ? error.message : 'An unknown error occurred');
    }
});
export const createWordSearch = createAsyncThunk('wordSearches/create', async (wordSearch, { fulfillWithValue, rejectWithValue }) => {
    try {
        const createdWordSearch = await wordSearchService.createWordSearch(wordSearch);
        return fulfillWithValue({ wordSearch: { ...createdWordSearch } });
    }
    catch (error) {
        return rejectWithValue(error instanceof Error ? error.message : 'An unknown error occurred');
    }
});
export const getWordSearch = createAsyncThunk('wordSearches/getOne', async (wordSearchId, { fulfillWithValue, rejectWithValue }) => {
    try {
        const wordSearch = await wordSearchService.getWordSearchDetails(wordSearchId);
        return fulfillWithValue({ wordSearch });
    }
    catch (error) {
        return rejectWithValue(error instanceof Error ? error.message : 'An unknown error occurred');
    }
});
export const updateWordSearch = createAsyncThunk('wordSearches/update', async ({ wordSearchId, data, }, { fulfillWithValue, rejectWithValue }) => {
    try {
        const wordSearch = await wordSearchService.updateWordSearch(wordSearchId, data);
        return fulfillWithValue(wordSearch);
    }
    catch (error) {
        return rejectWithValue(error instanceof Error ? error.message : 'An unknown error occurred');
    }
});
export const deleteWordSearch = createAsyncThunk('wordSearches/delete', async (wordSearchId, { fulfillWithValue, rejectWithValue }) => {
    try {
        await wordSearchService.deleteWordSearch(wordSearchId);
        return fulfillWithValue({ wordSearchId });
    }
    catch (error) {
        return rejectWithValue(error instanceof Error ? error.message : 'An unknown error occurred');
    }
});
export const updateWordSearchStatus = createAsyncThunk('wordSearches/publish', async ({ wordSearchId, status, }, { fulfillWithValue, rejectWithValue }) => {
    try {
        const wordSearch = await wordSearchService.updateWordSearchStatus(wordSearchId, status);
        return fulfillWithValue(wordSearch);
    }
    catch (error) {
        return rejectWithValue(error instanceof Error ? error.message : 'An unknown error occurred');
    }
});
export const updateWords = createAsyncThunk('wordSearches/updateWords', async ({ wordSearchId, words, }, { fulfillWithValue, rejectWithValue }) => {
    try {
        const data = await wordSearchService.updateWords(wordSearchId, words);
        return fulfillWithValue(data);
    }
    catch (error) {
        return rejectWithValue(error instanceof Error ? error.message : 'An unknown error occurred');
    }
});
